package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.ColorFilter
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p18
import com.example.mystybag.core.ui.theme.LocalTheme.p36
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.rippleClick
import com.example.mystybag.common.ui.components.native.Texts

@Composable
fun NavigationTabItem(
    modifier        : Modifier      = Modifier,
    text            : String        = "",
    onCloseClick    : () -> Unit    = { }
) {
    Box(
        modifier            = modifier
            .height(p36)
            .widthIn(min = p36)
            .clip(shape = RoundedCornerShape(p18))
            .background(color = AppTheme.current.colors.surface),
        contentAlignment    = Alignment.Center
    ) {
        Row(
            modifier                = Modifier.padding(horizontal = p12),
            verticalAlignment       = Alignment.CenterVertically,
            horizontalArrangement   = Arrangement.spacedBy(p4)
        ) {
            Texts.LabelMedium(text = text)

            Image(
                modifier    = Modifier
                    .rippleClick(padding = p4, action = onCloseClick)
                    .size(p16),
                painter     = painterResource(SRC.images.navigation_close),
                colorFilter = ColorFilter.tint(color = AppTheme.current.colors.onSurface)
            )
        }
    }
}